import classNames from "classnames";
import React from "react";

const classNamePrefix = "Spinner";

type SpinnerProps = React.HTMLAttributes<HTMLDivElement>;

export const Spinner = React.forwardRef(
  (props: SpinnerProps, ref?: React.ForwardedRef<HTMLDivElement>) => {
    const {
      "aria-label": ariaLabel = "Merci de patienter…",
      className,
      role = "status",
      ...restProps
    } = props;
    return (
      <div
        ref={ref}
        {...restProps}
        aria-label={ariaLabel}
        className={classNames(className, classNamePrefix)}
        role={role}
      />
    );
  },
);
